export default "__VITE_ASSET__81d1ebf9__"